import React, { useState } from 'react';
import { Card, Button, Badge, Modal } from 'react-bootstrap';
import api from '../../api/axios';
import AgregarPedidoModal from './AgregarPedidoModal';
import HistorialPedidosMesa from './HistorialPedidoMesa';

const MesaCard = ({ mesa, onRefresh }) => {
  const { id, name, status, comensales_total, opened_at } = mesa;
  const [showAgregarPedido, setShowAgregarPedido] = useState(false);
  const [showVer, setShowVer] = useState(false);
  const business = JSON.parse(localStorage.getItem('business'));
const [totalPedidos, setTotalPedidos] = useState(0);

  const statusColors = {
    libre: 'success',
    ocupada: 'danger',
    en_espera: 'warning',
    abonada: 'secondary',
    para_cobrar: 'info',
  };

  const mesaEditable = status.toLowerCase() === 'ocupada';

  const desasignar = async () => {
    if (!window.confirm(`¿Querés desasignarte de la mesa ${name}?`)) return;
    try {
      await api.patch(`/mesas/${id}/desasignar`);
      onRefresh();
    } catch (err) {
      console.error('Error al desasignar mesa:', err);
      alert('No se pudo desasignar la mesa');
    }
  };

  const solicitarCobro = async (mesaId) => {
    if (!window.confirm('¿Deseás enviar la mesa a caja para cobrar?')) return;
    try {
      const res = await api.patch(`/mesas/${mesaId}/solicitar-cobro`);
      alert(`Enviado a caja. Total: $${res.data.total}`);
      onRefresh();
    } catch (err) {
      console.error('Error al solicitar cobro:', err);
      alert('No se pudo procesar');
    }
  };

  const formattedTime = opened_at
    ? new Date(new Date(opened_at).getTime() - new Date(opened_at).getTimezoneOffset() * 60000)
        .toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
    : '-';

  return (
    <>
      <Card className="shadow-sm mb-3 border-0 rounded-3">
        <Card.Body>
          <Card.Title className="d-flex align-items-center justify-content-between">
            <span className="fs-5 fw-bold">Mesa {name}</span>
            <Badge bg={statusColors[status.toLowerCase()] || 'secondary'} className="text-capitalize">
              {status}
            </Badge>
          </Card.Title>

          <Card.Text className="mt-2 text-muted small">
            👥 <strong>Comensales:</strong> {comensales_total || '-'} <br />
            ⏰ <strong>Desde:</strong> {formattedTime}
          </Card.Text>

          <div className="d-grid gap-2 mt-3">
            <Button
              variant="primary"
              size="sm"
              onClick={() => setShowAgregarPedido(true)}
              disabled={!mesaEditable}
            >
              ➕ Agregar pedido
            </Button>

            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setShowVer(true)}
              disabled={!mesaEditable}
            >
              📋 Ver pedidos
            </Button>

            <Button
              variant="outline-success"
              size="sm"
              onClick={() => solicitarCobro(id)}
              disabled={!mesaEditable}
            >
              💰 Solicitar cobro
            </Button>

            <Button
              variant="outline-danger"
              size="sm"
              onClick={desasignar}
              disabled={!mesaEditable}
            >
              🚫 Desasignar
            </Button>
          </div>
        </Card.Body>
      </Card>

      {/* Modal agregar pedido */}
      <AgregarPedidoModal
        show={showAgregarPedido}
        onHide={() => setShowAgregarPedido(false)}
        mesaId={id}
        businessId={business?.id}
        onPedidoConfirmado={() => {
          setShowAgregarPedido(false);
          onRefresh();
        }}
      />

      {/* Modal ver historial */}
<Modal show={showVer} onHide={() => setShowVer(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Historial de pedidos - Mesa {name}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <HistorialPedidosMesa
      mesaId={id}
      businessId={business?.id}
      mostrarAcciones={false}
      onTotalChange={(total) => setTotalPedidos(total)}
    />
  </Modal.Body>
  <Modal.Footer className="justify-content-end">
    <strong>Total acumulado:</strong> ${totalPedidos.toFixed(2)}
  </Modal.Footer>
</Modal>

    </>
  );
};

export default MesaCard;
